import { render } from "./DeclarationIncidentModal.vue?vue&type=template&id=27496e7f&scoped=true"
import script from "./DeclarationIncidentModal.vue?vue&type=script&lang=js"
export * from "./DeclarationIncidentModal.vue?vue&type=script&lang=js"

import "./DeclarationIncidentModal.vue?vue&type=style&index=0&id=27496e7f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27496e7f"]])

export default __exports__